<template>
	<div class="rt60">
		<div
			style="height:650px;overflow:hidden;position: relative;background-image: url('productImg/module.jpg');    background-size: auto 100%;
    background-position-x: 300px;"
			class="mainTop"
			:style="{ height: Mobile + 'px' }"
		>
			<div
				class="feature_one_content_desc_right fright"
				style="    position: absolute;
    z-index: 1;
    left: 20%;
    top: 50%;
    transform: translate(10px, -50%);
    width: 600px;"
			>
				<p
					class="title"
					style="text-align: left;    color: #3e3e3e;
    font-size: 32px;    margin-bottom: 30px;"
				>
					<font
						style="    color: #e64023;
    margin: 0;
    padding: 0;
    font-size: 32px;
"
						>Firefly</font
					>-RK3288 高性能开源平台
				</p>
				<!-- <p class="summary">高性能开源平台</p> -->
				<p class="descs" style="text-align: left">
					Firefly-RK3288
					是一个高性能平台，拥有强大的多线程运算能力、图形处理能力以及硬件解码
					能力，而且支持Android和Ubuntu双系统，所以它也是一台强大的小型电脑，它可以用来做很多事情，也能嵌入到很多产品中，但我们希望你的创意和灵感能让它变得不平凡。
				</p>
			</div>
			<img
				v-if="showMobile"
				src="productImg/module_mobile.jpg"
				alt=""
				class="mobile"
				style="height:100%;position: relative;"
				:style="{ height: Mobile + 'px' }"
			/>
		</div>
		<div id="product-main" class="container" style="text-align: left">
			<div class="ai-sec">
				<div class="container">
          <div class="spec_title">
              <span style="font-size: 23px;color: #5e5e5e;padding-left: 16px;padding-bottom: 20px; width:153px; margin-top:36px;">参数</span>
              <span class="spec_title_name">Firefly-RK3288</span>
              <span class="spec_title_name" style="padding-left: 38px;">Firefly-RK3288 Reload</span>
          </div>
          <div style="width:1110px; margin:0 auto;">
                <table class="param_table" style="margin-bottom:61px;">
                  <tbody>
                  <tr>
                      <td class="dimen_left">主控芯片</td>
                      <td class="dimen_right"><p>Rockchip RK3288 (28纳米HKMG制程）</p></td>
                      <td class="dimen_right dimen_line"><p>Rockchip RK3288 (28纳米HKMG制程）</p></td>
                  </tr>
                  <tr>
                      <td class="dimen_left">处理器 </td>
                      <td class="dimen_right">ARM® Cortex™-A17 四核 1.8GHz</td>
                      <td class="dimen_right dimen_line">ARM® Cortex™-A17 四核 1.8GHz</td>
                  </tr>
                  <tr>
                      <td class="dimen_left dimen_left_top">图形处理器</td>
                      <td class="dimen_right ">
                          <p style="height:52px;">ARM® Mali-T760 MP4 支持OpenGL ES 1.1/2.0 /3.0, OpenVG1.1, OpenCL, Directx11</p>
                          <p>内嵌高性能2D 加速硬件</p>
                          <p style="height:52px; padding-right:30px;">支持4K H.264 和 10bits H.265视频解码，1080P 多格式视频解码</p>
                          <p>1080P 视频编码，支持H.264，VP8 和MVC</p>
                      </td>
                      <td class="dimen_right dimen_line">
                          <p style="height:52px;">ARM® Mali-T760 MP4 支持OpenGL ES 1.1/2.0 /3.0, OpenVG1.1, OpenCL, Directx11</p>
                          <p>内嵌高性能2D 加速硬件</p>
                          <p style="height:52px; padding-right:30px;">支持4K H.264 和 10bits H.265视频解码，1080P 多格式视频解码</p>
                          <p>1080P 视频编码，支持H.264，VP8 和MVC</p>
                      </td>
                  </tr>
                  <tr>
                      <td class="dimen_left">内存</td>
                      <td class="dimen_right">2GB 双通道DDR3 (Plus版为4GB)</td>
                      <td class="dimen_right dimen_line">2GB 双通道DDR3</td>
                  </tr>
                  <tr>
                      <td class="dimen_left">存储器</td>
                      <td class="dimen_right">
                          <p>16GB 高速eMMC (Plus版为32GB)</p>
                          <p>MicroSD (TF) 卡</p>
                      </td>
                      <td class="dimen_right dimen_line">
                          <p>16GB 高速 eMMC</p>
                          <p>MicroSD (TF) 卡</p>
                          <p><span style="color:#eb6242;">SATA 2.0 (建议使用 2.5英寸 SSD 或 HDD)</span></p>
                      </td>
                  </tr>
                  <tr>
                      <td class="dimen_left">电源管理</td>
                      <td class="dimen_right">ACT8846 PMU芯片</td>
                      <td class="dimen_right dimen_line">ACT8846 PMU芯片</td>
                  </tr>
                  <tr>
                      <td class="dimen_left dimen_left_top">以太网</td>
                      <td class="dimen_right">
                          <p>10/100/1000Mbps以太网 (Realtek RTL8211E)</p>
                      </td>
                      <td class="dimen_right dimen_line">
                          <p>10/100/1000Mbps以太网 (Realtek RTL8211E)</p>
                      </td>
                  </tr>
                  <tr>
                      <td class="dimen_left dimen_left_top">无线网络</td>
                      <td class="dimen_right">
                          <p>集成二合一WiFi模块（AP6335）：</p>
                          <p>WiFi 2.4GHz/5GHz双频 支持802.11a/b/g/n/ac协议
                          </p><p>Bluetooth 4.0（支持BLE）</p>
                      </td>
                      <td class="dimen_right dimen_line">
                          <p>集成二合一WiFi模块（AP6335）：</p>
                          <p>WiFi 2.4GHz/5GHz双频 支持802.11a/b/g/n/ac协议</p>
                          <p>Bluetooth 4.0（支持BLE）</p>
                      </td>
                  </tr>
                  <tr>
                      <td class="dimen_left videoparam dimen_left_top">视频</td>
                      <td class="dimen_right">
                          <p>支持多路视频高清输出:</p>
                          <p>1 x HDMI 2.0 , 支持4K@60帧输出</p>
                          <p>1 x VGA，支持1080P输出</p>
                          <p>1 x MIPI、1 x EDP、2 x LVDS 液晶屏显示接口</p>
                      </td>
                      <td class="dimen_right dimen_line">
                          <p>1 x HDMI 2.0 , 支持4K@60帧输出</p>
                          <p><span style="color:#eb6242;">1 x HDMI 1.4 , 支持1080P@60帧输出</span></p>
                          <p><span style="color:#eb6242;">1x HDMI-IN，HDMI视频输入，可支持画中画，录像功能</span></p>
                          <p>1 x MIPI、1 x EDP、2 x LVDS 液晶屏显示接口</p>
                      </td>
                  </tr>
                  <tr>
                      <td class="dimen_left dimen_left_top">音频</td>
                      <td class="dimen_right">
                          <p>1 x HDMI音频输出</p>
                          <p>1 x 耳麦接口，用于音频输入输出 </p>
                          <p>1 x SPDIF 数字音频接口，用于音频输出</p>
                          <p>1 x 麦克风，用于音频输入</p>
                          <p>1 x I2S ，用于音频输入输出 </p>
                      </td>
                      <td class="dimen_right dimen_line">
                          <p>2 x HDMI音频输出</p>
                          <p>1 x 耳麦接口，用于音频输入输出 </p>
                          <p>1 x SPDIF 数字音频接口，用于音频输出</p>
                          <p>1 x 麦克风，用于音频输入</p>
                          <p>1 x I2S ，用于音频输入输出 </p>
                      </td>
                  </tr>
                  <tr>
                      <td class="dimen_left">摄像头</td>
                      <td class="dimen_right">
                          <p>1 x MIPI-CSI摄像头接口 （最高支持13Mpixel ）</p>
                      </td>
                      <td class="dimen_right dimen_line">
                          <p>1 x MIPI-CSI摄像头接口 （最高支持13Mpixel ）</p>
                          <p><span style="color:#eb6242;">1 x DVP摄像头接口（最高支持5Mpixel）</span></p>
                      </td>
                  </tr>
                  <tr>
                      <td class="dimen_left">USB</td>
                      <td class="dimen_right">
                          <p>2 x USB2.0 HOST，1 x USB2.0 OTG</p>
                          <p>在板背面保留4组USB2.0接口</p>
                      </td>
                      <td class="dimen_right dimen_line">
                          <p>3 x USB2.0 HOST，1 x USB2.0 OTG</p>
          
                      </td>
                  </tr>
                  <tr>
                      <td class="dimen_left">红外</td>
                      <td class="dimen_right">1 x 红外接收头，支持红外遥控功能</td>
                      <td class="dimen_right dimen_line">1 x 红外接收头，支持红外遥控功能</td>
                  </tr>
                  <tr>
                      <td class="dimen_left">LED</td>
                      <td class="dimen_right">1 x 电源状态LED (蓝色) ，1 x 自定义LED (绿色)</td>
                      <td class="dimen_right dimen_line">1 x 电源状态LED (蓝色) ，1 x 自定义LED (绿色)</td>
                  </tr>
                  <tr>
                      <td class="dimen_left">按键</td>
                      <td class="dimen_right">1 x 复位键，1 x 电源键，1 x 升级键</td>
                      <td class="dimen_right dimen_line">1 x 复位键，1 x 电源键，1 x 升级键</td>
                  </tr>
                  <tr>
                      <td class="dimen_left">调试 </td>
                      <td class="dimen_right">1 x 调试串口，用于开发调试</td>
                      <td class="dimen_right dimen_line">1 x 调试串口，用于开发调试</td>
                  </tr>
                  <tr>
                      <td class="dimen_left dimen_left_top">预留接口</td>
                      <td class="dimen_right">
                          <p>84 Pins排针：</p>
                          <p>MIPI、MIPI-CSI、Dual LVDS、EDP、PWM、SPI、</p>
                          <p>UART、ADC、GPIO、I2C、I2S </p>
                      </td>
                      <td class="dimen_right dimen_line">
                          <p>184 Pins排针：</p>
                          <p>MIPI、Dual LVDS、EDP、PWM、SPI、UART、ADC、</p>
                          <p>GPIO、I2C、I2S</p>
                      </td>
                  </tr>
                  <tr>
                      <td class="dimen_left">电源</td>
                      <td class="dimen_right">DC5V - 2.5A ( 通过DC4.0*1.7mm座供电)</td>
                      <td class="dimen_right dimen_line">DC12V - 1.5A ( 通过DC 5.5*2.1mm座供电)</td>
                  </tr>
                  <tr>
                      <td class="dimen_left">系统</td>
                      <td class="dimen_right">Android 4.4、5.1 /  Ubuntu 14.04</td>
                      <td class="dimen_right dimen_line">Android 5.1 /  Ubuntu 14.04</td>
                  </tr>
          
                  <tr>
                      <td class="dimen_left">尺寸</td>
                      <td class="dimen_right">118mm × 85mm</td>
                      <td class="dimen_right dimen_line">主板：178mm x 117mm，核心板：82mm x 60mm</td></tr>
                  <tr>
                      <td class="dimen_left lastparam">重量</td>
                      <td class="dimen_right lastparam">77g</td>
                      <td class="dimen_right lastparam dimen_line">176g</td>
                  </tr>
                  </tbody>
                </table>
            </div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import '../../public/css/font-awesome.min.css'
import '../../public/lib/response_table.css'
import '../../public/lib/response_table.css'
import jQuery from '../../public/js/jquery.min.js'
import '../../public/lib/response_table.js'
import topNav from '../components/top'
import banner from '../components/banner'
import footerBot from '../components/footerBot'
import { mapMutations } from 'vuex'

export default {
	name: 'product',
	components: {
		topNav,
		banner,
		footerBot,
	},
	data() {
		return {
			screenWidth: document.body.clientWidth,
			showMobile: false,
			Mobile: 650,
			menu: 'capture',
			a_attr:
				'https://confluence.neucore.com/display/KB/NeuCamera?preview=/15925632/23593054/NeuCamera%E4%BA%A7%E5%93%81%E8%A7%84%E6%A0%BC%E4%B9%A6_%E4%BA%BA%E8%84%B8%E6%8A%93%E6%8B%8D_v1.2.pdf',
			detail_label0: 'detail_label0',
			detail_label1: 'detail_label1',
			detail_label2: 'detail_label2',
			moduleDesctiption: 'moduleDesctiption',
		}
	},
	methods: {
		...mapMutations(['editMenu']),
	},
	watch: {
		$route(to, from) {
			console.log(to, from)
			if (to.query.id) {
				this.menu = to.query.id
				this.detail_h1 = this['allWord'][to.query.id]['h1']
				this.a_attr = this['allWord'][to.query.id]['attr']
				console.log(this.menu)
			} else {
				this.menu = 'capture'
			}
		},
	},
	mounted() {
		console.log(this.$route)
		if (this.$route.query) {
			if (this.$route.query.id) {
				this.menu = this.$route.query.id
				this.detail_h1 = this['allWord'][this.$route.query.id]['h1']
				this.a_attr = this['allWord'][this.$route.query.id]['attr']
			} else {
				this.menu = 'capture'
			}
		}
		if (this.screenWidth < 480 || this.screenWidth === 480) {
			this.showMobile = true
			this.Mobile = window.screen.height
		}
		// jQuery("#table").basictable();
		this.editMenu('product')
		var Expand = (function() {
			var tile = $('.strips__strip')
			var tileLink = $('.strips__strip > .strip__content')
			var tileText = tileLink.find('.strip__inner-text')
			var stripClose = $('.strip__close')
			var expanded = false
			var open = function() {
				var tile = $(this).parent()
				if (!expanded) {
					tile.addClass('strips__strip--expanded')
					tileText.css(
						'transition',
						'all .6s 1s cubic-bezier(0.23, 1, 0.32, 1)'
					)
					stripClose.addClass('strip__close--show')
					stripClose.css(
						'transition',
						'all .6s 1s cubic-bezier(0.23, 1, 0.32, 1)'
					)
					expanded = true
				}
			}
			var close = function() {
				if (expanded) {
					tile.removeClass('strips__strip--expanded')
					tileText.css(
						'transition',
						'all 0.05s 0 cubic-bezier(0.23, 1, 0.32, 1)'
					)
					stripClose.removeClass('strip__close--show')
					stripClose.css(
						'transition',
						'all 0.2s 0s cubic-bezier(0.23, 1, 0.32, 1)'
					)
					expanded = false
				}
			}
			var bindActions = function() {
				tileLink.on('click', open)
				stripClose.on('click', close)
			}
			var init = function() {
				bindActions()
			}

			return {
				init: init,
			}
		})()
		Expand.init()
	},
}
</script>

<style scoped>
html,
body,
p,
ol,
ul,
li,
dl,
dt,
dd,
blockquote,
figure,
fieldset,
legend,
textarea,
pre,
iframe,
hr {
  margin: 0;
  padding: 0;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: normal;
}

ul,
ol {
  list-style: none;
}

input {
  border: none;
  outline: none;
  /* 清除表单在移动端浏览器默认的样式 ：阴影 3d */
  -webkit-appearance: none;
}
.fleft {
  float: left;
}
.fright {
  float: right;
}
/*清浮动*/
.clearfix:after {
  content: '';
  display: inline-block;
  width: 0;
  height: 0;
  clear: both;
  visibility: hidden;
}
.clearfix {
  zoom: 1;
}

a,
a:hover,
a:visited,
a:link,
a:active {
  text-decoration: none;
}
body {
  /*padding-top: 70px; 暂时关掉，先完成页面布局 有问题再改*/
  /*background: #f5f5f5;*/
  font-size: 14px;

  /* PC 端 */
  font-family: "Helvetica Neue", Helvetica, Tahoma, "PingFang SC ", "Hiragino Sans GB", "Microsoft YaHei", SimSun, sans-serif;

  /* 移动端 */
  /*font-family: -apple-system, system-ui, Tahoma, "PingFang SC ", "Hiragino Sans GB", "Microsoft YaHei", SimSun, sans-serif;*/
}

body.body-white {
  background: #fff;
}
h1 {
  font-size: 24px;
}
h2 {
  font-size: 20px;
}
h3 {
  font-size: 17px;
}
h4 {
  font-size: 14px;
}

.m-header .navbar {
  background-color: #fd6c07;
}

.navbar-fixed-top,
.navbar-fixed-bottom {
  position: fixed;
}

.navbar-fixed-top,
.navbar-fixed-bottom,
.navbar-static-top {
  margin-right: 0px;
  margin-left: 0px;
}

/*tc widget*/
.tc-main {
  margin-top: 20px;
}

/*tc-box*/
.tc-box {
  background: #fff;
  padding: 5px 10px;
  margin: 0 0 10px 0;
}

.body-white .tc-box {
  border: solid 1px #eee;
}

.tc-box.first-box {
  margin: 0 0 10px 0;
}

.tc-box.article-box {
  padding: 5px 20px;
}

.tc-gridbox-container {
  width: 25%;
  float: left;
}

.tc-gridbox {
  -webkit-border-radius: 0px;
  -moz-border-radius: 0px;
  border-radius: 0px;
  border: solid 1px #eee;
  background: #fff;
  cursor: pointer;
}

.tc-gridbox {
  margin: 0 10px 20px 10px;
}

.tc-gridbox:hover {
  -webkit-box-shadow: 0 0 10px 1px rgba(50, 50, 50, 0.1);
  -moz-box-shadow: 0 0 10px 1px rgba(50, 50, 50, 0.1);
  box-shadow: 0 0 10px 1px rgba(50, 50, 50, 0.1);
}

.tc-gridbox a {
  text-decoration: none;
}

@media (min-width: 768px) and (max-width: 979px) {
  .tc-gridbox {
    display: block;
    float: none;
    width: 95%;
  }
}

@media (max-width: 979px) {
  .tc-gridbox-container {
    display: block;
    float: none;
    width: 100%;
  }

  .tc-gridbox {
    margin: 0 0 10px 0;
  }
}

.tc-gridbox .header {
  padding-top: 0px;
  padding-right: 0px;
  padding-left: 0px;
  text-align: center;
  background: #fff;
}

.tc-gridbox .footer {
  padding: 5px 14px 5px 14px;
  text-align: right;
  background: #fff;
}

.tc-gridbox .header .item-image {
  overflow: hidden;
  width: 100%;
  height: 0;
  padding-bottom: 100%;
}

.tc-gridbox .header img {
  margin-bottom: 5px;
  width: 100%;
}

.tc-gridbox .header h3 {
  color: #454a4e;
  margin: 0 5px;
  font-size: 16px;
  text-overflow: ellipsis;
  overflow: hidden;
  line-height: 24px;
}

.tc-gridbox .header h3 a,
.tc-gridbox .header h3 a:focus,
.tc-gridbox .header h3 a:hover {
  color: #454a4e;
  white-space: nowrap;
}

.tc-gridbox .header .meta {
  color: #5a6065;
}

.tc-gridbox .header hr {
  border-top-color: #eee;
  border-bottom: none;
  margin: 5px 0;
}

.tc-gridbox .body {
  padding-right: 14px;
  padding-left: 14px;
  margin-bottom: 14px;
  color: #343a3f;
}

.tc-gridbox .body a {
  color: #666;
}

.tc-gridbox .body a:hover {
  color: #428bca;
}

.tc-gridbox .btn {
  float: right;
  margin-right: 10px;
  margin-bottom: 18px;
}

/*masonary*/

.masonary-container .item {
  margin-bottom: 20px;
}

.masonary-container .item h3 {
  line-height: 100%;
}

.masonary-container .grid-sizer,
.masonary-container .item {
  width: 24.9%;
  margin: 10px 0.05%;
  float: left;
  zoom: 1;
}

@media (max-width: 479px) {
  .masonary-container .grid-sizer,
  .masonary-container .item {
    width: 98%;
    margin: 10px 1%;
    float: left;
    zoom: 1;
  }
}

@media (min-width: 480px) and (max-width: 767px) {
  .masonary-container .grid-sizer,
  .masonary-container .item {
    width: 48%;
    margin: 10px 1%;
    float: left;
    zoom: 1;
  }
}

/*list Boxes
------------------------------------*/
.list-boxes {
  overflow: hidden;
  padding: 15px 20px;
  margin-bottom: 25px;
  background: #fff;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  word-wrap: break-word;
  word-break: break-all;
  border: solid 1px #eee;
}

.list-boxes:hover {
  border: solid 1px #ddd;
}

.list-boxes h2 a {
  color: #555;
}

.list-boxes:hover h2 a {
  color: #f90;
}

.list-boxes .list-actions a {
  font-size: 16px;
  text-decoration: none;
}

.list-boxes p a {
  color: #72c02c;
}

.list-boxes .list-boxes-img li i {
  color: #72c02c;
  font-size: 12px;
  margin-right: 5px;
}

.list-boxes .list-boxes-img img {
  display: block;
  margin: 5px 10px 10px 0;
}

.list-boxes h2 {
  margin-top: 0;
  font-size: 20px;
  line-height: 20px;
}

.list-boxes ul.list-boxes-rating li {
  display: inline;
}

.list-boxes ul.list-boxes-rating li i {
  color: #f8be2c;
  cursor: pointer;
  font-size: 16px;
}

.list-boxes ul.list-boxes-rating li i:hover {
  color: #f8be2c;
}

/*list Colored Boxes*/
.list-boxes-colored p,
.list-boxes-colored h2 a,
.list-boxes-colored .list-boxes-img li,
.list-boxes-colored .list-boxes-img li i {
  color: #fff;
}

/*Red list Box*/
.list-boxes-red {
  background: #e74c3c;
}

/*Blue list Box*/
.list-boxes-blue {
  background: #3498db;
}

/*Grey list Box*/
.list-boxes-grey {
  background: #95a5a6;
}

/*Turquoise list Box*/
.list-boxes-sea {
  background: #1abc9c;
}

/*Turquoise Top Bordered list Box*/
.list-boxes-top-sea {
  border-top: solid 2px #1abc9c;
}

.list-boxes-top-sea:hover {
  border-top-color: #16a085;
}

/*Yellow Top Bordered list Box**/
.list-boxes-top-yellow {
  border-top: solid 2px #f1c40f;
}

.list-boxes-top-yellow:hover {
  border-top-color: #f39c12;
}

/*Orange Left Bordered list Box**/
.list-boxes-left-orange {
  border-left: solid 2px #e67e22;
}

.list-boxes-left-orange:hover {
  border-left-color: #d35400;
}

/*Green Left Bordered list Box**/
.list-boxes-left-green {
  border-left: solid 2px #72c02c;
}

.list-boxes-left-green:hover {
  border-left-color: #5fb611;
}

/*Green Right Bordered list Box**/
.list-boxes-right-u {
  border-right: solid 2px #72c02c;
}

.list-boxes-right-u:hover {
  border-right-color: #5fb611;
}

/*comments*/
.comment {
  margin-bottom: 10px;
}

.comment .avatar {
  height: 40px;
  width: 40px;
}

.comment-body {
  overflow: hidden;
}

.comment-content {
  padding-bottom: 2px;
  word-break: break-all;
  word-wrap: break-word;
}

.comment > .pull-left {
  margin-right: 10px;
}

.comment .time {
  color: #ccc;
  font-size: 12px;
  line-height: 14px;
}

.comment-postbox {
  width: 100%;
  padding: 10px;
}

.comment-reply-box {
  position: relative;
}

.comment-reply-box .textbox {
  width: 100%;
}

.comment-reply-submit .btn {
  margin-top: 20px;
}

/*ranking box*/

.ranking ul li {
  padding: 5px 0;
  height: 36px;
  line-height: 36px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-bottom: 1px dashed #f0f0f0;
}

.ranking ul.unstyled li i {
  margin-right: 5px;
}

.ranking li i {
  display: inline-block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  margin-right: 15px;
  font-style: normal;
  font-weight: bold;
  color: #fff;
  text-align: center;
  vertical-align: middle;
  background-color: #aaa;
}

.ranking li.top3 i {
  background: #fc9b0b;
}

/*comment ranking box*/
.comment-ranking .comment-ranking-inner {
  padding: 10px;
  background: #f7f7f7;
  position: relative;
  margin-bottom: 10px;
  /*border-top: solid 2px #eee;*/
}

.comment-ranking .comment-ranking-inner,
.comment-ranking .comment-ranking-inner:after,
.comment-ranking .comment-ranking-inner:before {
  transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -webkit-transition: all 0.3s ease-in-out;
}

.comment-ranking .comment-ranking-inner:after,
.comment-ranking .comment-ranking-inner:before {
  width: 0;
  height: 0;
  right: 0px;
  bottom: 0px;
  content: ' ';
  display: block;
  position: absolute;
}

.comment-ranking .comment-ranking-inner:after {
  border-top: 15px solid #eee;
  border-right: 15px solid transparent;
  border-left: 0px solid transparent;
  border-left-style: inset; /*FF fixes*/
  border-right-style: inset; /*FF fixes*/
}

.comment-ranking .comment-ranking-inner:before {
  border-bottom: 15px solid #fff;
  border-right: 0 solid transparent;
  border-left: 15px solid transparent;
  border-left-style: inset; /*FF fixes*/
  border-bottom-style: inset; /*FF fixes*/
}

.comment-ranking .comment-ranking-inner:hover {
  border-color: #fc9b0b;
  border-top-color: #fc9b0b;
  background: #f0f0f0;
}

.comment-ranking .comment-ranking-inner:hover:after {
  border-top-color: #fc9b0b;
}

.comment-ranking .comment-ranking-inner span.comment-time {
  color: #777;
  display: block;
  font-size: 11px;
}

.comment-ranking .comment-ranking-inner a {
  text-decoration: none;
}

.comment-ranking .comment-ranking-inner a:hover {
  text-decoration: underline;
}

.comment-ranking .comment-ranking-inner i.fa {
  top: 2px;
  color: #bbb;
  font-size: 18px;
  position: relative;
}

/*ThinkCMF Photos*/
ul.tc-photos {
  margin: 0;
}

.tc-photos li {
  display: inline;
}

.tc-photos li a {
  text-decoration: none;
}

.tc-photos li img {
  opacity: 0.6;
  width: 50px;
  height: 50px;
  margin: 0 2px 8px;
  border: 1px solid #ddd;
}

.tc-photos li img:hover {
  opacity: 1;
  border: 1px solid #f90;
  /* box-shadow: 0 0 0 1px #f90; */
}

/**/

/*Blog Posts
------------------------------------*/

.posts .dl-horizontal {
  margin-bottom: 15px;
  overflow: hidden;
}

.posts .dl-horizontal dt {
  width: 60px;
  float: left;
}

.posts .dl-horizontal dt .img-wraper {
  display: block;
  width: 55px;
  height: 55px;
  padding: 1px;
  margin-top: 2px;
  border: solid 1px #ddd;
}

.posts .dl-horizontal dt img {
  width: 100%;
  height: 100%;
}

.posts .dl-horizontal dd {
  margin-left: 70px;
}

.posts .dl-horizontal dd p {
  margin: 0;
}

.posts .dl-horizontal dd a {
  font-size: 14px;
  line-height: 16px !important;
}

.posts .dl-horizontal dd a:hover {
  text-decoration: none;
}

.posts .dl-horizontal:hover dt img,
.posts .dl-horizontal:hover dd a {
  color: #fc9b0b;
  border-color: #fc9b0b !important;
  -webkit-transition: all 0.4s ease-in-out;
  -moz-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
}
/* -----------Nav开始------------- */
.m-header {
  width: 100%;
  height: 258px;
  background-color: pink;
  padding-bottom: 84px;
  line-height: 78px;
}

.m-header .navbar {
  height: 78px;
  margin-bottom: auto;
  color: #fff;
}

.m-header .navbar a {
  color: #fff;
}

.m-header .navbar a:hover,
a:active,
a:link,
a:visited {
  background-color: transparent;
}

.m-header .navbar-img {
  float: left;
  /*padding: 0 15px;*/
  font-size: 18px;
  line-height: 20px;
  height: 70px;
  margin-right: 45px;
}
.m-header .navbar-left,
.navbar-right {
  /*line-height: 50px;*/
  padding: 10px 0;
}

.m-header .navbar-right li {
  margin: 10px 15px;
  line-height: 40px;
}
.m-header .nav .nav-icon {
  height: 21px;
}
.m-header .nav-icon a {
  padding: 15px 5px;
}

/*左侧导航的1级标题进行宽距设置 不影响二级菜单*/
.m-header .navbar-left li[class*='level-1'] > a {
  padding: 25px 25px;
}

.m-header .navbar-right .btn {
  width: 80px;
  height: 30px;
  padding: 4px 0;
  background-color: rgba(0, 0, 0, 0.5);
  border: none;
  /*margin-top: 15px;*/
}
/* 选择最后两个按钮的li */
.m-header .navbar-right li:nth-last-child(-n + 2) {
  margin-top: 15px;
  color: #fff;
}

.m-header .m-search {
  padding-top: 80px;
}
.m-header .m-search .form-group span {
  font-size: 20px;
  color: #fff;
  display: inline-block;
  position: relative;
  top: 5px;
}
.m-header .m-search .form-control {
  width: 524px;
  height: 38px;
  margin: 0 10px;
  background-color: rgba(0, 0, 0, 0.5);
  border-color: #fff;
  color: #fff;
}
.m-header .m-search .form-control::-webkit-input-placeholder {
  color: #bababa;
}
.m-header .m-search .form-control::-moz-placeholder {
  color: #bababa;
}
.m-header .m-search .form-control:-moz-placeholder {
  color: #bababa;
}
.m-header .m-search .form-control:-moz-placeholder {
  color: #bababa;
}

.m-header .m-search .btn-primary {
  width: 74px;
  height: 38px;
  background-color: #f60;
  border: none;
  font-size: 18px;
  padding: 0 0;
}

/* tab栏组件 */
.m-tab .nav-tabs > li {
  margin: 0 25px;
  font-size: 20px;
}
.m-tab .nav-tabs > li:first-child {
  margin-left: 0;
}
.m-tab .nav-tabs > li:last-child {
  margin-right: 0;
}
.m-tab .nav-tabs > li > a {
  color: #0b0b0b;
  font-size: 18px;
}
.m-tab .nav-tabs > li.active > a,
.m-tab .nav-tabs > li.active > a:hover,
.m-tab .nav-tabs > li.active > a:focus {
  color: #ff7518;
  /*background-color: #f5f5f5;*/
  border: none;
  border-bottom: 2px solid #ff7518;
  /* border-bottom-color: transparent; */
  cursor: default;
}

/*第一栏：教程资料*/
.m-tab .tab-content {
  padding-bottom: 100px;
}
.m-tab .t-title {
  padding: 20px 0 40px;
}
.m-tab .t-title > p {
  font-size: 16px;
  color: #555;
}

.main {
  width: 1110px;
  margin: 0 auto 0 auto;
}

/*     Rk3399概述     */

.firefly_banner1,
.firefly_banner2,
.firefly_banner3,
.firefly_banner4,
.firefly_banner5,
.firefly_banner6,
.firefly_banner7,
.firefly_banner8,
.firefly_banner9,
.firefly_banner10,
.firefly_banner11 {
  width: 100%;
  height: 100%;
  background-size: 100%;
}
.firefly_banner11 {
  padding: 100px 0;
  background-color: #ccc;
}
.fy_img_full {
  height: 931px;
}
.fy_img_full2,
.fy_img_full3 {
  height: 867px;
}
.fy_img_full4,
.fy_img_full6 {
  height: 807px;
}
.fy_img_full5 {
  height: 861px;
}
.fy_img_full7 {
  height: 1117px;
}
.fy_img_full8 {
  height: 782px;
}
.fy_img_full9 {
  height: 918px;
}
.fy_img_full10 {
  height: 824px;
}
.fy_img_full11 {
  height: 900px;
}

/*    Rk3399 参数    */

.paramtop {
  width: 100%;
  overflow: hidden;
  background-color: #f0f0f0;
  margin-top: 120px;
}
td {
  padding: 10px 0 10px 0px;
}
.dimen_left {
  height: 31px;
  font-size: 16px;
  color: #3d3d3d;
  padding-left: 16px;
  border-right: #ddd solid 1px;
  border-top: #ddd solid 1px;
  width: 25%;
  /*font-family: Arial, Helvetica, sans-serif, "微软雅黑";*/
}
.can_left {
  height: 40px;
  font-size: 16px;
  color: #FFFFFF;
  border-right:#A0A0A0 solid 1px;
  border-top:#A0A0A0 solid 1px;
  width: auto;
  /*font-family: Arial, Helvetica, sans-serif, "微软雅黑";*/
  background: #7ECEF4;
  text-align: center;
  padding: 20px 0;
}
.can_right {
  font-size: 15px;
  padding-left: 37px;
  color: #3C3C3C;
  border-top: #A0A0A0 solid 1px;
  /*font-family: Arial, Helvetica, sans-serif,"微软雅黑";*/
  width: 471px;
  line-height: 3;
}
.can_right p {
  /*height: 26px;*/
  line-height: 36px;
  font-size: 14px;
}
.can_lastparam{
  border-bottom: 1px solid #A0A0A0 ;
}
.text-center{
  text-align: center;
}
.dimen_right {
  font-size: 15px;
  padding-left: 37px;
  color: #636262;
  border-top: #ddd solid 1px;
  /*font-family: Arial, Helvetica, sans-serif,"微软雅黑";*/
  width: 471px;
  line-height: 3;
}
.dimen_right_border {
  border-right: #ddd solid 1px;
}
.dimen_line {
  border-left: #ddd solid 1px;
}
.param_img {
  width: 1110px;
  margin: 100px auto 50px auto;
  height: 356px;
}
.param_table {
  width: 1110px;
  margin: 0 auto 0px auto;
}
.videoparam {
  height: 76px;
  line-height: 140%;
}
.lastparam {
  border-bottom: #dfdfdf solid 1px;
}
.oddtable {
  background: #ededed;
}
span {
  /* display: inline-block; */
  zoom: 1;
}
.fir3param_img {
  overflow: hidden;
  position: relative;
  min-width: 1280px;
  height: 580px;
}
.fir3param_img .param_bg {
  width: 100%;
  height: 363px;
  background-size: 100%;
  /* background: url(../images/rk3399/ti_pic.png) no-repeat top center; */
  margin-top: 80px;
}
.fir3param_img ul {
  width: 942px;
  margin: 0 auto;
}
.fir3param_img ul li.fl_param {
  width: 405px;
  text-align: center;
  margin-right: 200px;
}
.fir3param_img ul li {
  float: left;
  font-size: 16px;
  color: #666;
  margin-top: 42px;
  text-align: center;
  min-width: 330px;
}

.spec_title {
  margin: 0 auto;
  width: 1110px;
  font-size: 20px;
  color: #5e5e5e;
}

.spec_title .spec_title_name {
  width: 433px;
  padding-left: 34px;
  margin-top: 38px;
}

.spec_title .spec_title_finame {
  width: 433px;
  padding-left: 160px;
  margin-top: 38px;
}

.dimen_tuxing p {
  padding-bottom: 27px;
}
.dimen_right p {
  /*height: 26px;*/
  line-height: 26px;
  font-size: 14px;
}
.dimen_right p img{
  margin-top: 20px;
  max-height: 167px;
}
.dimen_left_top {
  vertical-align: top;
  padding-top: 20px;
}

.feature_banner {
  width: 100%;
  text-align: center;
  background: #f0f0f0;
  margin-top: 120px;
  height: 509px;
  padding-top: 20px;
}
.choose {
  margin-bottom: 33px;
  height: 110px;
  margin-top: 58px;
}
.choose h3 {
  margin-top: 58px;
  font-size: 24px;
  color: #717070;
  text-align: center;
  margin-bottom: 27px;
  font-weight: 100;
}
.choose span {
  background: #eee;
  margin-right: -1px;
  border: 1px solid #afafaf;
}
.choose .rk3288_on {
  color: #ffffff;
  background: #f60;
  border: 1px solid #afafaf;
}
.choose .rk3288_reload_on {
  color: #ffffff;
  background: #f60;
  border: 1px solid #afafaf;
}
.choose .left{
  border-radius: 15px 0px 0px 15px;
}
.choose .right{
  border-radius: 0px 15px 15px 0px;
}
.choose li a {
  -webkit-transition: all 0.2s linear;
  -moz-transition: all 0.2s linear;
  -ms-transition: all 0.2s linear;
  -o-transition: all 0.2s linear;
  transition: all 0.2s linear;
}
.interface_choose ul li a:hover {
  -webkit-box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  -webkit-transform: translate3d(0, -2px, 0);
  -moz-transform: translate3d(0, -2px, 0);
  -ms-transform: translate3d(0, -2px, 0);
  -o-transform: translate3d(0, -2px, 0);
  transform: translate3d(0, -2px, 0);
}
.switch_rk3399 .left {
  /* background: url(../images/board/hv_be.png) no-repeat; */
  margin-right: -1px;
}

.switch_rk3399 .rk3399_on {
  /* background: url(../images/board/choose01.png) no-repeat; */
  color: #ffffff;
}

.switch_rk3399 .right {
  /* background: url(../images/board/choose02.png) no-repeat; */
  color: #555;
}

.switch_rk3399 .rk3399_rd_on {
  /* background: url(../images/board/39_hxb_hv_af.png) no-repeat; */
  color: #ffffff;
}

.interface_choose ul {
  padding: 0 84px;
  margin-top: 20px;
}
.choose span {
  width: 275px;
  height: 46px;
  line-height: 46px;
  font-size: 20px;
  color: #454545;
  cursor: pointer;
  float: left;
  font-size: 16px;
}
.rk3288_reload .feature_one {
  height: auto;
}
.spec_title span {
  float: left;
}

.switch_rk3399 {
  width: 542px;
  height: 44px;
  margin: 58px auto;
}

.switch_rk3399 span {
  width: 271px;
  height: 44px;
  line-height: 44px;
  font-size: 20px;
  color: #454545;
  cursor: pointer;
  float: left;
  text-align: center;
}
.rk3399_hxb {
  width: 100%;
  height: 1730px;
}

/* rk3399规格 */
.interface {
  clear: both;
  padding-top: 40px;
  margin-top: 40px;
  width: 1110px;
  text-align: center;
  margin: 110px auto 10px auto;
  /* margin-top: 40px; */
}

.interface_choose h2 {
  font-size: 30px;
  color: #333333;
  font-weight: 100;
  margin-bottom: 20px;
}
.interface_choose p {
  font-size: 17px;
  color: #6e6d6d;
  line-height: 28px;
  padding: 0 68px;
}
.interface_choose ul li {
  float: left;
  width: 290px;
  padding: 0 12px;
}
.interface_choose ul li a {
  display: block;
  transition: all 0.2s linear;
}
.interface_choose .brick-item-img {
  height: 210px;
  display: table-cell;
  vertical-align: middle;
  width: 310px;
  background: white;
}
.interface_choose .brick-item-title {
  background: rgba(51, 51, 51, 1);
  color: white;
  font-weight: 300;
  font-size: 18px;
  padding: 8px 0;
}
.interface .interface_3399 {
  width: 670px;
  margin: 0 auto;
  margin-top: 50px;
}
.interface_choose ul li.on .brick-item-title {
  background: rgba(222, 85, 49, 1);
}

.interface_3399 ul li {
  float: left;
  width: 290px;
}
.interface_3399 ul li a {
  display: block;
  transition: all 0.2s linear;
  text-decoration: none;
}
.interface_choose ul li.on span,
.interface_3399 ul li.on span {
  /* background: url(../images/board/interface_select.png) no-repeat; */
  width: 28px;
  height: 21px;
  display: block;
  margin: 0 auto;
  margin-top: 8px;
}
.interface_3399 ul li a .brick-item39-img {
  height: 210px;
  display: table-cell;
  vertical-align: middle;
  width: 310px;
  background: white;
}
.interface_3399 ul li.on .brick-item-title {
  background: #e75f02;
}
.interface_3399 ul li .brick-item-title {
  background: #aaa;
  color: white;
  font-weight: 300;
  font-size: 18px;
  padding: 8px 0;
}

.choose_bottom {
  border-bottom: 1px solid #d3d3d3;
  height: 164px;
  background: #f0f0f0;
  margin-top: 152px;
}
.choose_bottom3399 {
  border-bottom: 1px solid #d3d3d3;
  height: 164px;
  background: #f0f0f0;
  margin-top: 182px;
}

.interface_main {
  width: 1110px;
  margin: 0 auto;
}
.interface_line {
  height: 1px;
  width: 100%;
  background: #e3e3e3;
}
.im_item {
  margin-top: 55px;
}
.im_head span {
  width: 3px;
  height: 24px;
  background: #de5531;
  display: inline-block;
  margin-right: 12px;
  /* margin: auto 0; */
  /* line-height: 30px; */
  margin-top: 5px;
  float: left;
}
.im_head p {
  font-size: 24px;
  color: #363636;
}
.im_item_img {
  width: 100%;
  text-align: center;
}

/*  rk3288 内容*/
.fleft {
  float: left;
}
.fright {
  float: right;
}
/*.feature_one{height:483px;}*/
.feature_three,
.feature_one {
  width: 100%;
  background: whitesmoke;
  float: left;
}

.title1 {
  font-size: 32px;
  color: #3e3e3e;
}
.title2 {
  color: #717070;
  font-size: 20px;
}
.title3 {
  font-size: 28px;
  color: #3e3e3e;
}

.param_one_content,
.feature_three_content,
.feature_one_content {
  width: 960px;
  margin: 0 auto;
}
.feature_one_content_title {
  /*height:82px;*/
  margin: 0;
  width: 100%;
  /*margin-top:41px;*/
}
.param_one_content_title_left,
.feature_one_content_title_left {
  margin-left: 35px;
  margin-top: 39px;
  font-size: 19px;
  padding-bottom: 5px;
  color: #000000;
  border-bottom: 2px solid #ef711a;
}
.param_one_content_title_right,
.feature_one_content_title_right {
  float: right;
  margin-top: 39px;
  margin-right: 31px;
}
.title_right {
  font-size: 17px;
  color: #3e3e3e;
}
.feature_four_tird .des,
.feature_one_content_title_right .des {
  *display: inline-block;
  padding-bottom: 5px;
  border-bottom: 2px solid #ef711a;
  *padding-bottom: 5px;
}
.feature_one_content_title_right .var {
  margin-right: 35px;
  *display: inline-block;
  *padding-bottom: 5px;
}
.param_one_content_title_right a,
.feature_one_content_title_right a,
.feature_four_tird a {
  color: #3e3e3e;
}
.pie {
  margin: 0 10px;
  /* background: url('../images/board/vspite.png') no-repeat center center; */
}
.clickbug {
  font-size: 18px;
  background: #61c691;
  padding: 4px 10px;
  color: #ffffff;
}
.feature_one_content_desc {
  width: 100%;
  float: left;
  /*margin-top:51px;*/
  text-align: center;
}
.feature_one_content_desc_left {
  width: auto;
}
.feature_one_content_desc_right {
  /*margin-right:63px;text-align:left;width:335px;*/
  width: 100%;
}
.feature_one_content_desc_right p.title {
  color: #3e3e3e;
  font-size: 32px;
  /* margin-top: 31px; */
  text-align: center;
  margin-bottom: 30px;
}
.feature_one_content_desc_right p.title font {
  color: #e64023;
  margin: 0;
  padding: 0;
  font-size: 32px;
}
.feature_one_content_desc_right p.summary {
  color: #717070;
  font-size: 32px;
  padding: 2px 0;
}
.feature_one_content_desc_right p.descs {
  /* color: #717070; */
  /* font-size: 18px; */
  /* line-height: 180%; */
  /* text-align: center; */
}
.feature_one_content_desc_right a.look {
  margin-top: 11px;
  /*background-image: url(../images/rk3288/w_video.png);*/
  background-repeat: no-repeat;
  height: 17px;
  width: 87px;
  display: block;
}
.feature_one_content_desc_right a:hover.look {
  /*background-image: url(../images/rk3288/w_video-ho.png);*/
  background-repeat: no-repeat;
}
.feature_four,
.feature_two {
  width: 100%;
  background: #f5f5f5;
  float: left;
}
.feature_two_first {
  height: 371px;
}
.feature_four_tird,
.feature_four_first,
.feature_four_sec,
.feature_two_tird,
.feature_two_sec,
.feature_two_first {
  width: 960px;
  margin: 0 auto;
}
.feature_two_first_left {
  margin: 60px 0 0 35px;
  width: 520px;
}
.feature_two_tird_left p.summary,
.feature_two_sec_right p.summary,
.feature_two_first_left p.summary {
  font-size: 32px;
  color: #3e3e3e;
}
.feature_two_tird_left p.desc,
.feature_two_sec_right p.desc,
.feature_two_first_left p.desc {
  color: #717070;
  font-size: 20px;
  line-height: 130%;
  padding-top: 7px;
}
.feature_two_first_left img {
  margin-top: 18px;
}
.feature_two_first_right img {
  margin: 99px 63px 0 0;
}
.feature_two_sec {
  height: 407px;
}
.feature_two_sec_left {
  margin: 90px 0 0 83px;
}
.feature_two_sec_right {
  width: 400px;
  margin: 35px 35px 0 0;
}
.feature_two_sec_right img {
  margin-top: 34px;
}
.feature_two_tird {
  height: 354px;
  background: none;
}
.feature_two_tird_left {
  margin: 51px 0 0 112px;
}
.feature_two_tird_right {
  margin: 80px 35px 0 0;
}
.topad {
  margin: 7px 0 0 15px;
}
.feature_two_tird_left img {
  margin: 0 35px;
}
.feature_three {
  height: 618px;
}

.feature_three_content .summary {
  padding: 61px 0 9px 0;
  text-align: center;
}
.feature_four_first .desc,
.feature_three_content .desc {
  text-align: center;
  line-height: 130%;
}
.feature_three_content_left,
.feature_three_content_right {
  margin-top: 51px;
  width: 440px;
}
.piclogo {
  margin: 20px 7px 0 151px;
}
.feature_three_content_left p,
.feature_three_content_right p {
  padding-top: 35px;
}
.feature_three_content_left {
  margin-left: 6px;
}
.feature_three_content_right {
  margin-right: 6px;
}
.feature_four_first {
  height: 444px;
}
.feature_four_first span {
  float: left;
  width: 1px;
  display: inline-block;
  height: 270px;
  border-left: #d5d5d5 solid 1px;
  margin: 90px 0 0 38px;
}
.feature_four_first_left {
  margin-left: 0px;
}
.feature_four_first_right {
  width: 490px;
  margin-right: 0px;
}
.feature_four_first_left,
.feature_four_first_right {
  margin-top: 90px;
  text-align: center;
}
.feature_four_first .summary {
  margin-bottom: 10px;
}

.feature_four_sec {
  height: 612px;
  *height: 685px;
  text-align: center;
}
.feature_four_sec .summary {
  margin: 60px 0 19px 0;
}
.feature_four_tird .var {
  *padding-bottom: 5px;
  *display: inline-block;
}
.feature_four_tird {
  height: 101px;
  background: none;
  text-align: center;
  padding-top: 40px;
}
.param_one_content {
  height: 103px;
}
.param_one_content_title {
  width: 100%;
  padding-left: 0;
  margin-top: 11px;
}
.param_one_content .des {
  *display: inline-block;
  *padding-bottom: 5px;
}
.param_one_content .var {
  margin-right: 35px;
  *display: inline-block;
  padding-bottom: 5px;
  *padding-bottom: 5px;
  border-bottom: 2px solid #ef711a;
}
.param_table {
  width: 1110px;
  margin: 0 auto 0px auto;
}
/*.dimen_left{
    height: 31px;
    font-size: 17px;
    color: #3d3d3d;
    padding-left: 16px;
    border-right: #DDD solid 1px;
    border-top: #DDD solid 1px;
    width: 165px;
    font-family: Arial, Helvetica, sans-serif, "微软雅黑";
}*/
/*.dimen_right{
    font-size: 15px;
    padding-left: 37px;
    color: #636262;
    border-top: #DDD solid 1px;
    font-family: Arial, Helvetica, sans-serif, "微软雅黑";
    width: 471px;
}*/
.dimen_line {
  border-left: #ddd solid 1px;
}

.videoparam {
  height: 76px;
  line-height: 140%;
}
.lastparam {
  border-bottom: #dfdfdf solid 1px;
}
.oddtable {
  background: #ededed;
}
/*  rk3288规格 */
.interface_choose ul li {
  float: left;
  width: 290px;
  padding: 0 12px;
}

/*fireduino*/
.actived-value {
  -webkit-box-sizing: content-box;
  -moz-box-sizing: content-box;
  box-sizing: content-box;
}
.performs-value-right h1 {
  margin-top: 0;
  line-height: 1.5;
}
.audio-des {
  box-sizing: content-box;
}

/* --------Footer开始----------- */

/*foot-main公用样式*/
.f-main {
  /*height: 482px;*/
  width: 100%;
  background-color: #373d41;
  padding: 54px 0 70px 0;
  color: #ccc;
  font-size: 12px;
}
.f-main .container {
  position: relative;
  padding-left: 64px;
}
.f-main h6 {
  color: #999;
}
.f-main h4,
h5 {
  color: #cacbcc;
}
.f-main li {
  line-height: 2.5;
}
.f-main li a {
  font-weight: normal;
  color: #ccc;
}
.f-main h6 + li {
  margin-top: 2px;
}
/*第一栏*/
.f-main .item:first-child h4 {
  font-size: 16px;
}

.f-main .footer_img {
  position: absolute;
  top: 10px;
  left: 0;
}

/*竖线*/
.f-main .item:nth-child(1)::after {
  content: ' ';
  width: 1px;
  height: 330px;
  background-color: #797979;
  position: absolute;
  top: 10px;
  right: 25%;
}

.f-main .item:nth-last-child(2) ul {
  margin-bottom: 12px;
}
.f-main .item:nth-last-child(2) li {
  line-height: 1.65;
}
/*立即咨询的按钮*/
.f-main button {
  width: 96px;
  height: 26px;
  background-color: #ff6600;
  font-size: 14px;
  border: none;
  color: #fff;
}
/*办公地址的内容*/
.f-main .item:last-child li {
  line-height: 2;
}
.f-main .item:last-child ul:last-child {
  margin-top: 45px;
}
/* footer的备案信息 */
.record {
  height: 50px;
  background-color: #2b3033;
  font-size: 12px;
  color: #a1a1a1;
  line-height: 50px;
}

#footer .f-bottom p a,
#footer .f-bottom p a:hover,
#footer .f-bottom p a:link,
#footer .f-bottom p a:active,
#footer .f-bottom p a:visited {
  color: #a1a1a1;
  text-decoration: none;
}

/*立即咨询*/
#advice-box {
  width: 722px;
}
#advice-box .modal-header {
  height: 60px;
  background-color: #eaeaea;
  font-size: 22px;
}
#advice-box h3 {
  color: #555;
  /*font-weight: normal;*/
}

#advice-box .modal-body {
  padding: 33px 100px 47px;
}
#advice-box .body-title {
  font-size: 16px;
  color: #777;
  margin-bottom: 20px;
}
#advice-box .modal-body select {
  width: 520px;
  margin-bottom: 12px;
  /*清除select的默认样式*/
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  border-radius: 0px;
  /* background: url('../images/dropdown-arrow.png') right 14px center no-repeat; */
}
/*兼容IE*/
/*#advice-box .modal-body select::-ms-expand{*/
/*display: none;*/
/*}*/

.feedback_err {
  height: 34px;
  padding-left: 10px;
  border: 1px solid #ff6600;
}

.feedcontent_err {
  padding: 10px;
  width: 520px;
  height: 158px;
  margin-bottom: 12px;
  border: 1px solid #ff6600;
}

.feedcall_err {
  display: block;
  width: 100%;
  height: 34px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555;
  border: 1px solid #ff6600;
}

#advice-box .info-inp {
  width: 520px;
  height: 158px;
  border: 1px solid #dcdcdc;
  margin-bottom: 12px;
  resize: none;
  border-radius: 0px;
}
#advice-box .info-details:first-child {
  padding-right: 6px;
}
#advice-box .info-details:last-child {
  padding-left: 6px;
}

#advice-box .footer {
  margin-top: 20px;
  text-align: center;
}
#advice-box .btn {
  color: #fff;
  font-size: 16px;
  background-color: #e75f02;
  width: 174px;
  height: 36px;
  padding: 0;
}

/*地图信息*/
#map-box {
  width: 824px;
  height: 550px;
  border: 6px solid rgba(0, 0, 0, 0.4);
}
/*to Top*/
#backtotop .fa {
  background-color: #fff;
}

/*高德地图相关*/
.info-title {
  color: white;
  font-size: 14px;
  background-color: rgba(0, 155, 255, 0.8);
  line-height: 26px;
  padding: 0px 0 0 6px;
  font-weight: lighter;
  letter-spacing: 1px;
}
.info-content {
  padding: 4px;
  color: #666666;
  line-height: 23px;
}
.info-content img {
  float: left;
  margin: 3px;
}

.nav-tabs {
  height: 47px;
}
.nav-tabs > li > a:hover {
  border-color: transparent;
}
.nav > li > a:focus,
.nav > li > a:hover {
  background: none;
}

.container {
  width: 1200px;
  padding: 0;
}


.ws_consuling .ws_contact_mode {
  width: 190px;
  height: 272px;
  right: 52px;
  padding-top: 18px;
  padding-left: 17px;
  padding-right: 17px;
  /*background: url('../images/website/contact_pig.png') no-repeat;*/
  position: absolute;
  display: none;
  background: white;
  margin-right: 14px;
  box-shadow: 0 0 10px #d8d8d8;
}
.ws_contact_mode:before, .ws_contact_mode:after{
  border: solid transparent;
  content: ' ';
  height: 0;
  left: 100%;
  position: absolute;
  width: 0;
}
.ws_contact_mode:before {
  border-width: 10px;
  border-left-color: #f3f3f3;
  top: 20px;
}

.ws_contact_mode:after {
  border-width: 9px;
  border-left-color: #fff;
  top: 21px;
}

.ws_contact_mode .can_title,
.ws_contact_mode .work_time,
.contact_photo .phone_title {
  font-size: 14px;
  color: #ff7632;
}

.ws_contact_mode .contact_photo,
.ws_contact_mode .cen_contact,
.ws_contact_mode .juti_time {
  margin-top: 8px;
  margin-bottom: 10px;
}

.ws_contact_mode .juti_time p {
  font-size: 13px;
}

.cen_contact .kefu a {
  font-size: 13px;
  color: #666;
}
.table-indent {
  text-indent: 24px;
}

.product-part-h2 {
  color: #3c3c3c;
  font-size: 54px;
  padding-top: 110px;
  margin-top: 0;
}
.product-part-h4 {
  font-size: 20px;
  color: #646464;
  margin-top: 36px;
  margin-bottom: 54px;
}
.list-paddingleft-1 {
  padding-left: 25px;
}
.list-paddingleft-2 {
  padding-left: 40px;
}
.list-paddingleft-3 {
  padding-left: 55px;
}

.container-1200 {
  width: 1200px;
  position: relative;
  margin: 0 auto;
}

.pc_param_title{
  background: #F0F0F0;
  border-right:none;
  font-size: 28px;
  color: #636262;
  text-align: center;
}

/*解决方案追加*/
.content-topic{
  padding-top:81px;
  padding-bottom:31px;	
  font-size: 34px;
}

.sub-h{
  padding-bottom:31px;	
  color: #999999;
}

.content-what{text-align:center;background-color:#f9f9f9}
.content-what .what-list{font-size:0;height:448px;}
.content-what .what-list-mobile{display:none}
.content-what .what-more{display:none;max-width:682px;margin:0 auto;padding:0 40px;color:#323232;font-size:14px;text-align:left}
.content-what .what-item{display:inline-block;position:relative;width:60px;margin-left:-2px;line-height:1.6;font-size:14px;text-align:center;vertical-align:middle;background-color:#fff;color:#323232;border-radius:4px;box-shadow:0 0 10px 0 rgba(0,0,0,.15);transition:width .5s ease,height .5s ease,box-shadow .3s ease;cursor:pointer}
.content-backers .backers-detail,.content-invers .invers-item{box-shadow:0 0 4px 0 rgba(179,179,179,.17),inset 0 -3px 0 0 rgba(103,77,199,.05)}
/*.content-what .what-item:hover{background-image:linear-gradient(160deg,rgba(101,70,194,.2) 0,rgba(119,115,228,.2) 50%,rgba(93,136,238,.2) 100%)}*/
.content-what .what-item:hover{
background:#ffe0cc;
}
.content-what .what-item .what-item-bg{width:100%;height:100%;position:absolute;top:0;left:0;opacity:0;transition:opacity .4s ease .1s;border-radius: 4px;box-shadow: 0 0 10px 0 rgba(0,0,0,.15);}
.content-what .what-item span{visibility:visible;transition:opacity .15s ease .4s;position:absolute;width:14px;top:50%;left:22px;transform:translateY(-50%);word-wrap: break-word;white-space: normal;}

/* .content-what .what-item-1 .what-item-bg{background:url(../images/solution/gateway.png) center/cover no-repeat;background-size:100%;}
.content-what .what-item-2 .what-item-bg{background:url(../images/solution/vending_machine.png) center/cover no-repeat;background-size:100%;}
.content-what .what-item-3 .what-item-bg{background:url(../images/solution/passenger-flow.png) center/cover no-repeat;background-size:100%;}
.content-what .what-item-4 .what-item-bg{background:url(../images/solution/server2.png) center/cover no-repeat;background-size:100%;}
.content-what .what-item-5 .what-item-bg{background:url(../images/solution/face.png?v1) center/cover no-repeat;background-size:100%;}
.content-what .what-item-6 .what-item-bg{background:url(../images/solution/ranging.png?v1) center/cover no-repeat;background-size:100%;}
.content-what .what-item-7 .what-item-bg{background:url(../images/solution/features.png?v1) center/cover no-repeat;background-size:100%;} */

.content-what .what-item-active{width:857px;height:441px!important;background-size:cover;margin-right:2px;z-index:9!important;transition:width .4s ease,height .4s ease;}
.content-what .what-item-active span{visibility:hidden;opacity:0}
.content-what .what-item-active .what-item-bg{transition:opacity .5s ease 0s;opacity:1;visibility:visible}

.content-what .what-item:nth-child(1){height:388px;padding:0 22px;z-index:1}
.content-what .what-item:nth-child(2){height:408px;padding:0 22px;z-index:3}
.content-what .what-item:nth-child(3){height:428px;padding:0 22px;z-index:5}
.content-what .what-item:nth-child(4){height:448px;padding:0 22px;z-index:7}
.content-what .what-item:nth-child(5){height:428px;padding:0 22px;z-index:5}
.content-what .what-item:nth-child(6){height:408px;padding:0 22px;z-index:3}
.content-what .what-item:nth-child(7){height:388px;padding:0 22px;z-index:2}
/*.content-what .what-item:nth-child(8){height:388px;padding:0 22px;z-index:3}
.content-what .what-item:nth-child(9){height:368px;padding:0 22px;z-index:2}*/
@media (max-width:1320px){
.content-what .what-item-active{width:619.2px;height:409.5px!important;background-size:cover;margin-right:2px;z-index:9!important;transition:width .4s ease,height .4s ease;border:4px solid #fff}
.content-what .what-item-active span{visibility:hidden;opacity:0}
.content-what .what-item-active .what-item-bg{transition:opacity .5s ease 0s;opacity:1;visibility:visible}

.content-what .what-item:nth-child(1){height:349.2px;padding:0 22px;z-index:1}
  .content-what .what-item:nth-child(2){height:367.2px;padding:0 22px;z-index:3}
  .content-what .what-item:nth-child(3){height:385.2px;padding:0 22px;z-index:5}
  .content-what .what-item:nth-child(4){height:403.2px;padding:0 22px;z-index:7}
  .content-what .what-item:nth-child(5){height:385.2px;padding:0 22px;z-index:5}
  .content-what .what-item:nth-child(6){height:367.2px;padding:0 22px;z-index:3}
  .content-what .what-item:nth-child(7){height:349.2px;padding:0 22px;z-index:2}
}
/*解决方案追加结束*/

/*产品中心首页样式*/
.nav-top{
  height: 78px;
}
.product-nav{
  border-top: 1px #eeeeee solid;
  border-bottom: 1px #eeeeee solid;
  height:72px;
  display: flex;
}
.product-nav .nav-width{
  margin: 0px auto;
  padding:0px 50px;
}
.product-nav .nav-width li{
  margin: 25px 0px;
  float: left;
  padding: 0px 7px;
  height: 14px;
}
.product-nav .nav-width li.right-border{
  border-right: 1px #d2d2d2 solid;
}
.product-nav .nav-width li a{
  margin-top:-6px; 
  display: block;
  min-width: 120px;
  box-sizing: border-box;
  padding: 5px;
  color: #666666;
  font-size: 14px;
  text-align: center;
  font-weight: 500;
}
.product-nav .nav-width li a.active{
  background: #ff6600;
  border-radius: 17px;
  color: #ffffff;
}
.t-main h2{
  display: inline-block;
  color: #666666;
  font-size: 18px;
  line-height: 78px;
  height: 78px;
  margin: 0px;
}
.t-main .titlei{
  height: 22px;
  width: 3px;
  background: #ff6600;
  margin-right: 10px;
}
.product-item{
  width: 240px;
  height:311px;
  float:left;
  border: 1px #eeeeee solid;
  border-left:none;
  border-top:none;
}
.product-item.b{
  background: #f1f4f6;
}
.product-item.double{
  background: #f1f4f6;
}
.product-item.start{
  border-left: 1px #eeeeee solid;
}
.product-item img{
  width: 100%;
  position: relative;
  -webkit-box-reflect: below 0px -webkit-linear-gradient(bottom, rgba(255,255,255,0.3) 0%, transparent 10%, transparent 100%);
}
.father:after{
  display:block; 
  content:"clear";
  height:0; 
  clear:both;
  overflow:hidden; 
  visibility:hidden;
}
/*给父元素加border-top和border-left*/
.father{
  display:inline-block;
  border-top:1px #eeeeee solid;
}
.item-img{
  height: 200px;
  /* background: url(../images/product/square2.png) no-repeat; */
  background-position: center bottom; 
  padding: 0px 20px;
  padding-top:25px;
}
.product-item h5{
  margin-top: 0px;
  color: #333333;
  font-weight: bold;
  text-align: center;
}
.product-item h6{
  margin-top: 0px;
  color: #b9b9b9;
  text-align: center;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
  margin-bottom: 24px;
}
.product-item i{
  display:inline-block;
  width: 15px;
  height: 15px;
  border-radius: 15px;
  border: 1px #d2d2d2 solid;
}
.product-item i.active{
  border: none;
  /* background: url(../images/product_active.png) no-repeat top; */
}
.product-item .fun li{
  float: left;
  display: inline-block;
  width: 50%;
}
.product-item .fun .border-left{
  float: right;
  margin-top:-2px;
  display: inline-block;
  height: 24px;
  width: 1px;
  background: #e5e5e5;
}
.product-item .fun p{
  display: inline-block;
  font-size: 12px;
  vertical-align: text-top;
}
.product-item .fun li a{
  display: block;
  margin: 0px auto;
  height: 34px;
  text-align: center;
  width: 77px;
  font-size: 12px;
  line-height: 34px;
  color: #706f6f;
  border: 1px #d2d2d2 solid;
  border-radius: 34px;
}
.product-item .fun li a:hover{
  color: #FFFFFF;
  background: #ff6600;
  border: none;
}
.product-item .fun .contrast{
  margin-top:8px;
  padding-left:15px;
}

.advert{
  /* position: absolute; */
  position: fixed;
  width: 100%;
  height:100%;
  background:rgba(0, 0, 0, 0.4);
  z-index: 999;
  top:0px;
}
.advert img{
  display: block;
  position: relative;
  margin: 0px auto;
}

.adv-close{
  background-position-x: 0px;
  position: absolute;
  top:15%;
  right:20%;
}
.toTop{
  display: none;
  position: fixed;
  bottom: 20px;
  right: 5%;
  height: 50px;
  width: 50px;
  /* background: url(../images/totop.png) no-repeat; */
  background-size: cover;
  z-index: 999;
}
.nav_fixed{
  position: fixed;
  top:0px;
  background: #FFFFFF;
  z-index: 99999;
  width: 100%;
}
/* 产品中心结束 */

.news-main .m-content ul.list-paddingleft-2{
  float: none;
}
.news-main .m-content ul.list-paddingleft-2 li{
  float: none;
  list-style: disc;
}
.product-tag div{
  display: inline-table;
  float: left;
  height: 18px;
  color: white;
  font-size: 12px;
  line-height: 18px;
}
.product-tag .tag-title, .product-tag .tag-tail{
  padding: 0px;
  margin: 0px;
  height: 0px;
  width: 0px;
}

/* 文档标签 */
.green .tag-content{
  background: #7EBE7A;
}
.green .tag-title{
  border-left:9px solid #7EBE7A;
  border-top:9px solid rgba(0,0,0,0);
  border-bottom:9px solid  rgba(0,0,0,0);
  border-right:9px solid  rgba(0,0,0,0);
}
.green .tag-tail{
  border-left:9px solid rgba(0,0,0,0);
  border-top:9px solid #7EBE7A;
  border-bottom:9px solid  #7EBE7A;
  border-right:9px solid  #7EBE7A;
}
.young .tag-content{
  background: #2CBFB9;
}
.young .tag-title{
  border-left:9px solid #2CBFB9;
  border-top:9px solid rgba(0,0,0,0);
  border-bottom:9px solid  rgba(0,0,0,0);
  border-right:9px solid  rgba(0,0,0,0);
}
.young .tag-tail{
  border-left:9px solid rgba(0,0,0,0);
  border-top:9px solid #2CBFB9;
  border-bottom:9px solid  #2CBFB9;
  border-right:9px solid  #2CBFB9;
}
.brown .tag-content{
  background: #B78B69;
}
.brown .tag-title{
  border-left:9px solid #B78B69;
  border-top:9px solid rgba(0,0,0,0);
  border-bottom:9px solid  rgba(0,0,0,0);
  border-right:9px solid  rgba(0,0,0,0);
}
.brown .tag-tail{
  border-left:9px solid rgba(0,0,0,0);
  border-top:9px solid #B78B69;
  border-bottom:9px solid  #B78B69;
  border-right:9px solid  #B78B69;
}
.orange .tag-content{
  background: #FC8E3C;
}
.orange .tag-title{
  border-left:9px solid #FC8E3C;
  border-top:9px solid rgba(0,0,0,0);
  border-bottom:9px solid  rgba(0,0,0,0);
  border-right:9px solid  rgba(0,0,0,0);
}
.orange .tag-tail{
  border-left:9px solid rgba(0,0,0,0);
  border-top:9px solid #FC8E3C;
  border-bottom:9px solid  #FC8E3C;
  border-right:9px solid  #FC8E3C;
}
.pink .tag-content{
  background: #E57976;
}
.pink .tag-title{
  border-left:9px solid #E57976;
  border-top:9px solid rgba(0,0,0,0);
  border-bottom:9px solid  rgba(0,0,0,0);
  border-right:9px solid  rgba(0,0,0,0);
}
.pink .tag-tail{
  border-left:9px solid rgba(0,0,0,0);
  border-top:9px solid #E57976;
  border-bottom:9px solid  #E57976;
  border-right:9px solid  #E57976;
}
/* 文档标签 */



.display-flex{
  display: flex;
}
.display-flex-direction-column{
  flex-direction: column;
}

.choose .product-on {
  color: #ffffff;
  background: #f60;
  border: 1px solid #afafaf;
}

i.arrow-left:after {
  content: '';
  position: absolute;
  right: 10px;
  top: 50%;
  width: 8px;
  height: 8px;
  border-bottom: 1px solid #555;
  border-right: 1px solid #555;
  transform: rotate(-45deg);
  margin-top: -3px;
  transition: transform  .5s;
}
i.arrow-left.white:after {
  border-bottom: 1px solid #fff;
  border-right: 1px solid #fff;
}

blockquote {
	border: none;
}

#navbar-main {
}

#product-main {
	/* padding-bottom: 30px; */
}
.ai-sec {
	padding: 60px 0px;
}
h3 {
	color: #0085cb;
}

#headerwrap {
	background-size: 100% 100%;
	display: flex;
	align-items: center;
	justify-content: center;
}
#headerwrap h1 {
	margin-top: 0;
}

#headerwrap h2 {
	color: white;
	margin-bottom: 0;
}

#product-main .img-banner h3 {
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	color: white;
	font-size: 40px;
}
@media screen and (max-width: 1366px) {
	.mainTop {
		height: 440px;
	}
}
@media screen and (max-width: 480px) {
	.mainTop {
		height: 650px;
	}
	#product-main .img-banner {
		height: 170px;
		width: 100%;
		/* background: url(../../public/img/product/cpzx_banner@3x.jpg) no-repeat */
			/* center; */
		background-size: 100% 100%;
	}
	.mobile {
		width: auto !important;
		height: 100% !important;
	}
}

#product-main .product-info {
	/* padding: 50px 0px; */
	box-sizing: border-box;
}

#product-main .info-title,
#product-main .develop-title {
	margin-bottom: 10px;
	margin-top: 0px !important;
	/* color: white; */
	border-radius: 20px;
	padding: 10px;
	margin-bottom: 40px;
	/* background: orange; */
	border-radius: 24px;
	padding: 10px 30px;
	color: white;
	text-align: center;
	width: 100%;
}

#product-main .info-title {
	margin-top: 80px;
}
#product-main .info-main {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin: 0 auto;
}

#product-main .info-main img {
	width: 100%;
}

#product-main .info-title .title-text,
#product-main .develop-title .title-text {
	font-size: 30px;
	color: black;
}

.company-develop {
	width: 100%;
	margin: 0 auto;
	padding-top: 0px;
}
.mobileScroll {
	margin-top: 16px;
}
@media screen and (max-width: 480px) {
	.company-develop {
		width: 100%;
		margin: 0 auto;
	}
	.mobileScroll {
		width: 100%;
		overflow: scroll;
	}
}

.company-develop #myTabs {
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 30px;
}

.company-develop #myTabs li {
	flex: 1;
	text-align: center;
}

.case-core {
	overflow: hidden;
	background-position: center center;
	background-repeat: no-repeat;
	background-size: cover;
	height: 413px;
	transition: background-image 0.5s;
	margin-bottom: 60px;
	background-color: #08061e;
}

.case-core-list {
	height: 100%;
	width: 25%;
	float: left;
	border-right: 1px solid rgba(255, 255, 255, 0.4);
	padding: 100px 35px 0;
	position: relative;
	transition: all 0.5s;
	cursor: pointer;
}

.en .case-core-list {
	padding-top: 50px;
}

.case-core.cell1 .case-core-list {
	width: 100%;
	border-right: none;
}

.case-core.cell2 .case-core-list {
	width: 50%;
}

.case-core.cell3 .case-core-list {
	width: 33.33%;
}

.case-core-hover .case-core-list {
	padding-top: 62px;
	width: 20%;
}

.en .case-core-hover .case-core-list {
	padding-top: 20px;
}

.case-core-hover.cell2 .case-core-list {
	width: 33.3%;
}

.case-core-hover.cell3 .case-core-list {
	width: 25%;
}

.case-core-hover .case-core-list.current {
	width: 40%;
}

.case-core-hover.cell1 .case-core-list.current {
	width: 100%;
}

.case-core-hover.cell2 .case-core-list.current {
	width: 66.7%;
}

.case-core-hover.cell3 .case-core-list.current {
	width: 50%;
}

.case-core-list:last-of-type {
	border-right: none;
}

.case-core-list .case-logo {
	height: 58px;
	margin-bottom: 10px;
}

.case-core-list .case-title {
	font-size: 20px;
	line-height: 150%;
	margin-bottom: 10px;
	color: #fff;
}

.case-logo img {
	height: 100%;
	width: auto;
}

.case-summary h3 {
	font-size: 20px;
	color: #ffffff;
	line-height: 150%;
	margin-bottom: 15px;
}

.en .case-summary h3 {
	text-align: left;
}

.case-summary p {
	font-size: 14px;
	color: #ffffff;
	line-height: 150%;
	transition: all 0.5s;
	opacity: 0;
}

.case-core-list.current .case-summary p {
	opacity: 0.8;
}

.case-more-btn {
	height: 48px;
	width: 82px;
	/* background: rgba(0, 0, 0, 0.2) url(/sites/all/themes/yitu/images/more2.svg) */
	/* no-repeat center 18px; */
	border-radius: 24px;
	position: absolute;
	left: 35px;
	bottom: 70px;
	transition: all 0.5s;
	display: none;
}

.case-core-list.current .case-more-btn {
	opacity: 0;
}

.case-wrapper {
	padding: 80px 0;
	background: #fff;
}

.case-type {
	width: 140px;
	float: left;
}

.case-list {
	width: calc(100% - 140px);
	float: right;
}

.case-type .form-type-bef-link,
.case-type li {
	font-family: PingFangSC-Medium;
	color: #000000;
	width: 100%;
}

.case-type .form-type-bef-link a,
.case-type li a {
	color: #7f7f7f;
	padding: 12px 0 12px 24px;
	font-size: 18px;
	line-height: 150%;
	position: relative;
	width: 100%;
	display: block;
	transition: all 0.5s;
}

.case-type .form-type-bef-link a:before,
.case-type li a:before {
	position: absolute;
	content: '';
	display: block;
	width: 2px;
	height: 100%;
	left: 0;
	top: 0;
	overflow: hidden;
	background: #000;
	opacity: 0.1;
}

.case-type .form-type-bef-link a.active,
.case-type li.active a {
	color: #000;
}

.case-type .form-type-bef-link a.active:before,
.case-type li.active a:before {
	background-image: linear-gradient(-90deg, #6acaff 0%, #0b1cba 100%);
	opacity: 1;
}

.case-list ul {
	padding-left: 9px;
	margin-bottom: 0;
}

.case-list li {
	position: relative;
	width: 100%;
	background: #f4f5f9;
	padding: 60px;
	margin-bottom: 24px;
}

.case-list li h3 {
	font-size: 20px;
	color: #000000;
	margin-bottom: 20px;
}

.case-list li p {
	opacity: 0.7;
	font-size: 16px;
	color: #000000;
	line-height: 26px;
}

.case-list li span.type {
	display: block;
	height: 30px;
	padding: 0 10px;
	text-align: center;
	font-size: 16px;
	line-height: 28px;
	position: absolute;
	left: -9px;
	top: 12px;
	border-width: 1px;
	border-style: solid;
	background-color: #fff;
}

.case-list li span.type:before {
	content: '';
	display: block;
	width: 10px;
	height: 6px;
	position: absolute;
	left: -1px;
	bottom: -7px;
	background-position: 0 0;
	background-repeat: no-repeat;
	background-size: 10px;
}

.case-list li span.type.yuanqu {
	color: #189583;
	border-color: rgba(24, 149, 131, 0.1);
}

.case-list li span.type.yuanqu:before {
	/* background-image: url(/sites/all/themes/yitu/images/flag-yq.svg); */
}

.case-list li span.type.lingshou {
	color: #e07f16;
	border-color: rgba(224, 127, 22, 0.1);
}

.case-list li span.type.lingshou:before {
	/* background-image: url(/sites/all/themes/yitu/images/flag-ls.svg); */
}

.case-list li span.type.yiliao {
	color: #0060ff;
	border-color: rgba(0, 96, 255, 0.1);
}

.case-list li span.type.yiliao:before {
	/* background-image: url(/sites/all/themes/yitu/images/flag-yl.svg); */
}

.case-list li span.type.anfang {
	color: #000aff;
	border-color: rgba(0, 10, 255, 0.1);
}

.case-list li span.type.anfang:before {
	/* background-image: url(/sites/all/themes/yitu/images/flag-af.svg); */
}

.case-list li span.type.jinrong {
	color: #a38f33;
	border-color: rgba(163, 143, 51, 0.1);
}

.case-list li span.type.jinrong:before {
	/* background-image: url(/sites/all/themes/yitu/images/flag-jr.svg); */
}

.case-list li span.type.aicity {
	color: #a95454;
	border-color: rgba(169, 84, 84, 0.1);
}

.case-list li span.type.aicity:before {
	/* background-image: url(/sites/all/themes/yitu/images/flag-other.svg); */
}

.case-list li span.type.others {
	color: #e55354;
	border-color: rgba(69, 84, 184, 0.1);
}

.case-list li span.type.others:before {
	/* background-image: url(/sites/all/themes/yitu/images/flag-other.svg); */
}

[class^='icon-'],
[class*=' icon-'] {
	font-family: icomoon;
	speak: none;
	font-style: normal;
	font-weight: 400;
	font-variant: normal;
	text-transform: none;
	line-height: 1;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}

body,
html {
	font-size: 100%;
	padding: 0;
	margin: 0;
}

*,
*:after,
*:before {
	-webkit-box-sizing: border-box;
	-moz-box-sizing: border-box;
	box-sizing: border-box;
}

.clearfix:before,
.clearfix:after {
	content: ' ';
	display: table;
}

.clearfix:after {
	clear: both;
}

a {
	color: #2fa0ec;
	text-decoration: none;
	outline: 0;
}

a:hover,
a:focus {
	color: #74777b;
}

.htmleaf-container {
	margin: 0 auto;
	text-align: center;
	overflow: hidden;
}

.htmleaf-content {
	font-size: 150%;
	padding: 1em 0;
}

.htmleaf-content h2 {
	margin: 0 0 2em;
	opacity: 0.1;
}

.htmleaf-content p {
	margin: 1em 0;
	padding: 5em 0 0;
	font-size: 0.65em;
}

.bgcolor-1 {
	background: #f0efee;
}

.bgcolor-2 {
	background: #f9f9f9;
}

.bgcolor-3 {
	background: #e8e8e8;
}

.bgcolor-4 {
	background: #2f3238;
	color: #fff;
}

.bgcolor-5 {
	background: #df6659;
	color: #521e18;
}

.bgcolor-6 {
	background: #2fa8ec;
}

.bgcolor-7 {
	background: #d0d6d6;
}

.bgcolor-8 {
	background: #3d4444;
	color: #fff;
}

.bgcolor-9 {
	background: #ef3f52;
	color: #fff;
}

.bgcolor-10 {
	background: #64448f;
	color: #fff;
}

.bgcolor-11 {
	background: #3755ad;
	color: #fff;
}

.bgcolor-12 {
	background: #3498db;
	color: #fff;
}

.htmleaf-header {
	padding: 1em 190px;
	letter-spacing: -1px;
	text-align: center;
}

.htmleaf-header h1 {
	font-weight: 600;
	font-size: 2em;
	line-height: 1;
	margin-bottom: 0;
	font-family: segoe ui, lucida grande, Helvetica, Arial, microsoft yahei,
		FreeSans, Arimo, droid sans, wenquanyi micro hei, hiragino sans gb,
		hiragino sans gb w3, fontawesome, sans-serif;
}

.htmleaf-header h1 span {
	font-family: segoe ui, lucida grande, Helvetica, Arial, microsoft yahei,
		FreeSans, Arimo, droid sans, wenquanyi micro hei, hiragino sans gb,
		hiragino sans gb w3, fontawesome, sans-serif;
	display: block;
	font-size: 60%;
	font-weight: 400;
	padding: 0.8em 0 0.5em;
	color: #c3c8cd;
}

.htmleaf-demo a {
	color: #1d7db1;
	text-decoration: none;
}

.htmleaf-demo {
	width: 100%;
	padding-bottom: 1.2em;
}

.htmleaf-demo a {
	display: inline-block;
	margin: 0.5em;
	padding: 0.6em 1em;
	border: 3px solid #1d7db1;
	font-weight: 700;
}

.htmleaf-demo a:hover {
	opacity: 0.6;
}

.htmleaf-demo a.current {
	background: #1d7db1;
	color: #fff;
}

.htmleaf-links {
	position: relative;
	display: inline-block;
	white-space: nowrap;
	font-size: 1.5em;
	text-align: center;
}

.htmleaf-links::after {
	position: absolute;
	top: 0;
	left: 50%;
	margin-left: -1px;
	width: 2px;
	height: 100%;
	background: #dbdbdb;
	content: '';
	-webkit-transform: rotate3d(0, 0, 1, 22.5deg);
	transform: rotate3d(0, 0, 1, 22.5deg);
}

.htmleaf-icon {
	display: inline-block;
	margin: 0.5em;
	padding: 0;
	width: 1.5em;
	text-decoration: none;
}

.htmleaf-icon span {
	display: none;
}

.htmleaf-icon:before {
	margin: 0 5px;
	text-transform: none;
	font-weight: 400;
	font-style: normal;
	font-variant: normal;
	font-family: icomoon;
	line-height: 1;
	speak: none;
	-webkit-font-smoothing: antialiased;
}

.htmleaf-footer {
	width: 100%;
	padding-top: 10px;
}

.htmleaf-small {
	font-size: 0.8em;
}

.center {
	text-align: center;
}

.related {
	color: #fff;
	background: #333;
	text-align: center;
	font-size: 1.25em;
	padding: 0.5em 0;
	overflow: hidden;
}

.related > a {
	vertical-align: top;
	width: calc(100% - 20px);
	max-width: 340px;
	display: inline-block;
	text-align: center;
	margin: 20px 10px;
	padding: 25px;
	font-family: segoe ui, lucida grande, Helvetica, Arial, microsoft yahei,
		FreeSans, Arimo, droid sans, wenquanyi micro hei, hiragino sans gb,
		hiragino sans gb w3, fontawesome, sans-serif;
}

.related a {
	display: inline-block;
	text-align: left;
	margin: 20px auto;
	padding: 10px 20px;
	opacity: 0.8;
	-webkit-transition: opacity 0.3s;
	transition: opacity 0.3s;
	-webkit-backface-visibility: hidden;
}

.related a:hover,
.related a:active {
	opacity: 1;
}

.related a img {
	max-width: 100%;
	opacity: 0.8;
	border-radius: 4px;
}

.related a:hover img,
.related a:active img {
	opacity: 1;
}

.related h3 {
	font-family: microsoft yahei, sans-serif;
}

.related a h3 {
	font-weight: 300;
	margin-top: 0.15em;
	color: #fff;
}

.icon-htmleaf-home-outline:before {
	content: '\e5000';
}

.icon-htmleaf-arrow-forward-outline:before {
	content: '\e5001';
}

@media screen and (max-width: 50em) {
	.htmleaf-header {
		padding: 3em 10% 4em;
	}

	.htmleaf-header h1 {
		font-size: 2em;
	}
}

@media screen and (max-width: 40em) {
	.htmleaf-header h1 {
		font-size: 1.5em;
	}
}

@media screen and (max-width: 30em) {
	.htmleaf-header h1 {
		font-size: 1.2em;
	}
}

.strips {
	min-height: 50vh;
	text-align: center;
	overflow: hidden;
	color: #fff;
	width: 100%;
	position: relative;
}

.strips__strip {
	will-change: width, left, z-index, height;
	position: absolute;
	width: 25%;
	min-height: 46vh;
	overflow: hidden;
	cursor: pointer;
	-webkit-transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
	transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
}

.strips__strip:nth-child(1) {
	left: 0;
}

.strips__strip:nth-child(2) {
	left: 15vw;
}

.strips__strip:nth-child(3) {
	left: 30vw;
}

.strips__strip:nth-child(4) {
	left: 45vw;
}

.strips__strip:nth-child(1) .strip__content {
	background: #244f75;
	-webkit-transform: translate3d(-100%, 0, 0);
	transform: translate3d(-100%, 0, 0);
	-webkit-animation-name: strip1;
	animation-name: strip1;
	-webkit-animation-delay: 0.1s;
	animation-delay: 0.1s;
}

.strips__strip:nth-child(2) .strip__content {
	background: #60bfbf;
	-webkit-transform: translate3d(0, 100%, 0);
	transform: translate3d(0, 100%, 0);
	-webkit-animation-name: strip2;
	animation-name: strip2;
	-webkit-animation-delay: 0.2s;
	animation-delay: 0.2s;
}

.strips__strip:nth-child(3) .strip__content {
	background: #8c4b7e;
	-webkit-transform: translate3d(0, -100%, 0);
	transform: translate3d(0, -100%, 0);
	-webkit-animation-name: strip3;
	animation-name: strip3;
	-webkit-animation-delay: 0.3s;
	animation-delay: 0.3s;
}

.strips__strip:nth-child(4) .strip__content {
	background: #f8bb44;
	-webkit-transform: translate3d(0, 100%, 0);
	transform: translate3d(0, 100%, 0);
	-webkit-animation-name: strip4;
	animation-name: strip4;
	-webkit-animation-delay: 0.4s;
	animation-delay: 0.4s;
}

@media screen and (max-width: 760px) {
	.strips__strip {
		min-height: 12vh;
	}

	.strips__strip:nth-child(1) {
		top: 0;
		left: 0;
		width: 100%;
	}

	.strips__strip:nth-child(2) {
		top: 12vh;
		left: 0;
		width: 100%;
	}

	.strips__strip:nth-child(3) {
		top: 24vh;
		left: 0;
		width: 100%;
	}

	.strips__strip:nth-child(4) {
		top: 36vh;
		left: 0;
		width: 100%;
	}
}

.strips .strip__content {
	-webkit-animation-duration: 1s;
	animation-duration: 1s;
	-webkit-animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
	animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
	-webkit-animation-fill-mode: both;
	animation-fill-mode: both;
	display: -webkit-box;
	display: -webkit-flex;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	-webkit-align-items: center;
	-ms-flex-align: center;
	align-items: center;
	-webkit-box-pack: center;
	-webkit-justify-content: center;
	-ms-flex-pack: center;
	justify-content: center;
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	text-decoration: none;
}

.strips .strip__content:hover:before {
	-webkit-transform: skew(-30deg) scale(3) translate(0, 0);
	-ms-transform: skew(-30deg) scale(3) translate(0, 0);
	transform: skew(-30deg) scale(3) translate(0, 0);
	opacity: 0.1;
}

.strips .strip__content:before {
	content: '';
	position: absolute;
	z-index: 1;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: #fff;
	opacity: 0.05;
	-webkit-transform-origin: center center;
	-ms-transform-origin: center center;
	transform-origin: center center;
	-webkit-transform: skew(-30deg) scaleY(1) translate(0, 0);
	-ms-transform: skew(-30deg) scaleY(1) translate(0, 0);
	transform: skew(-30deg) scaleY(1) translate(0, 0);
	-webkit-transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
	transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
}

.ai_office {
	width: 100%;
	display: flex;
	align-items: center;
	margin-bottom: 20px;
	justify-content: center;
}

.ai_office > img {
	width: 70px !important;
	height: 60px;
	margin-right: 20px;
}

.ai_office p:nth-child(2) {
	font-size: 16px !important;
	margin-bottom: 0;
	text-align: left;
}

.mainAi {
	display: flex;
	flex-wrap: wrap;
}

.ai_sec {
	width: 50%;
}

.ai_sec > p {
	font-size: 20px;
}

.strips .strip__inner-text {
	will-change: transform, opacity;
	position: absolute;
	z-index: 5;
	top: 50%;
	left: 50%;
	width: 70%;
	-webkit-transform: translate(-50%, -50%) scale(0.5);
	-ms-transform: translate(-50%, -50%) scale(0.5);
	transform: translate(-50%, -50%) scale(0.5);
	opacity: 0;
	-webkit-transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
	transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
}

.strips__strip--expanded {
	width: 100%;
	top: 0 !important;
	left: 0 !important;
	z-index: 3;
	cursor: default;
}

@media screen and (max-width: 760px) {
	.strips__strip--expanded {
		min-height: 48vh;
	}
}

.strips__strip--expanded .strip__content:hover:before {
	-webkit-transform: skew(-30deg) scale(1) translate(0, 0);
	-ms-transform: skew(-30deg) scale(1) translate(0, 0);
	transform: skew(-30deg) scale(1) translate(0, 0);
	opacity: 0.05;
}

.strips__strip--expanded .strip__title {
	opacity: 0;
}

.strips__strip--expanded .strip__inner-text {
	opacity: 1;
	-webkit-transform: translate(-50%, -50%) scale(1);
	-ms-transform: translate(-50%, -50%) scale(1);
	transform: translate(-50%, -50%) scale(1);
}

.strips__strip--expanded .strip__inner-text p {
	font-size: 24px;
}

.strip__title {
	display: block;
	margin: 0;
	position: relative;
	z-index: 2;
	width: 100%;
	font-size: 40px;
	color: #fff;
	-webkit-transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
	transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
}

@media screen and (max-width: 760px) {
	.strip__title {
		font-size: 28px;
	}
}

.strip__close {
	position: absolute;
	right: 3vw;
	top: 3vw;
	opacity: 0;
	z-index: 10;
	-webkit-transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
	transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
	cursor: pointer;
	-webkit-transition-delay: 0.5s;
	transition-delay: 0.5s;
}

.strip__close--show {
	opacity: 1;
	font-size: 30px;
}

.pw100 {
	width: 100%;
	margin-top: 10%;
}

@-webkit-keyframes strip1 {
	0% {
		-webkit-transform: translate3d(-100%, 0, 0);
		transform: translate3d(-100%, 0, 0);
	}

	100% {
		-webkit-transform: translate3d(0, 0, 0);
		transform: translate3d(0, 0, 0);
	}
}

@keyframes strip1 {
	0% {
		-webkit-transform: translate3d(-100%, 0, 0);
		transform: translate3d(-100%, 0, 0);
	}

	100% {
		-webkit-transform: translate3d(0, 0, 0);
		transform: translate3d(0, 0, 0);
	}
}

@-webkit-keyframes strip2 {
	0% {
		-webkit-transform: translate3d(0, 100%, 0);
		transform: translate3d(0, 100%, 0);
	}

	100% {
		-webkit-transform: translate3d(0, 0, 0);
		transform: translate3d(0, 0, 0);
	}
}

@keyframes strip2 {
	0% {
		-webkit-transform: translate3d(0, 100%, 0);
		transform: translate3d(0, 100%, 0);
	}

	100% {
		-webkit-transform: translate3d(0, 0, 0);
		transform: translate3d(0, 0, 0);
	}
}

@-webkit-keyframes strip3 {
	0% {
		-webkit-transform: translate3d(0, -100%, 0);
		transform: translate3d(0, -100%, 0);
	}

	100% {
		-webkit-transform: translate3d(0, 0, 0);
		transform: translate3d(0, 0, 0);
	}
}

@keyframes strip3 {
	0% {
		-webkit-transform: translate3d(0, -100%, 0);
		transform: translate3d(0, -100%, 0);
	}

	100% {
		-webkit-transform: translate3d(0, 0, 0);
		transform: translate3d(0, 0, 0);
	}
}

@-webkit-keyframes strip4 {
	0% {
		-webkit-transform: translate3d(0, 100%, 0);
		transform: translate3d(0, 100%, 0);
	}

	100% {
		-webkit-transform: translate3d(0, 0, 0);
		transform: translate3d(0, 0, 0);
	}
}

@keyframes strip4 {
	0% {
		-webkit-transform: translate3d(0, 100%, 0);
		transform: translate3d(0, 100%, 0);
	}

	100% {
		-webkit-transform: translate3d(0, 0, 0);
		transform: translate3d(0, 0, 0);
	}
}
.rt60 {
	position: relative;
	top: -60px;
	margin-bottom: -60px;
}
.myBtn:active {
	background-color: unset !important;
	color: unset;
}
.myBtn:focus {
	outline: 0 !important;
}
#table {
	border: 1px solid #dee2e6;
	text-align: left;
}
#table1 {
	border: 1px solid #dee2e6;
	text-align: left;
}
#table2 {
	border: 1px solid #dee2e6;
	text-align: left;
}
#table3 {
	border: 1px solid #dee2e6;
	text-align: left;
}
#table4 {
	border: 1px solid #dee2e6;
	text-align: left;
}
.table th,
.table td {
	border-right: 1px solid #dee2e6;
}
.table thead th {
	border-bottom: 0 !important;
}
.tal {
	text-align: left;
}
.img100 {
	width: 100%;
}
.detail-p {
	padding-top: 20px;
	text-align: left;
	font-size: 14px;
	/* color: #999; */
}
a {
	color: unset;
}
.ptitle {
	width: 64px;
	height: 40px;
	line-height: 40px;
	/* display: block; */
	margin-bottom: 12px;
}
.ptitle {
	font-size: 16px;
	padding-bottom: 8px;
	border-bottom: 2px solid #409eff;
	/* background: rgba(255, 0, 0, .8); */
	color: #409eff;
}
.mt8 {
	margin-top: 12px;
}
p {
	margin-bottom: 8px;
}
.solutionDitails .block {
	width: 100%;
}
.solutionDitails .block img {
	width: 100%;
}
.solutionDitails .block h4 {
	font-size: 22px;
	/* // font-weight: ; */
}
.solutionDitails .block p {
	font-size: 16px;
	color: #999;
}
.pb0 {
	padding-bottom: 0;
}
.mypointer {
	cursor: pointer;
	overflow: hidden;
}
.mypointer h3 {
	transition: 0.4s;
}
.mypointer img {
	transition: 0.6s;
}
.mypointer:hover img {
	transform: scale(1.1);
}
.mypointer:before {
	position: absolute;
	z-index: 1;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	content: '';
	/* transition: opacity 5s cubic-bezier(.23,1,.32,1),height 5s cubic-bezier(.23,1,.32,1); */
	opacity: 0;
	transition: 0.6s;
	background: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.2));
}
.mypointer:hover:before {
	opacity: 1;
}
.mypointer:hover h3 {
	transform: translateY(-30px);
}
.pb130 {
	padding-bottom: 130px;
}
.pb0 {
	padding-bottom: 0;
}
.topChange {
	display: flex;
	width: 375px;
	margin: 0 auto;
	position: absolute;
	top: -66px;
	left: 50%;
	transform: translate(-50%, 0);
	height: 66px;
	line-height: 66px;
}
.topChange li {
	padding: 0 20px;
	font-size: 20px;
	color: white;
	cursor: pointer;
}
.topChange li.active {
	background: white;
	color: #0067ed;
}
.img-block {
	width: 85%;
}
.advantage-show {
	height: 480px;
	background: url(../../public/img/Solution/line_dot-3f88c.png) no-repeat 50%;
	background-size: contain;
	position: relative;
	transition: all 0.3s;
}
.aos-animate {
	opacity: 1;
	transform: scale(1);
}
.advantage-box {
	height: 170px;
	background: #fff;
	border-radius: 4px;
	text-align: center;
	margin-bottom: 20px;
	transition: all 0.5s;
}
.advantage-show li p {
	background: #fff;
	padding: 8px 20px;
	position: absolute;
	bottom: 0;
	left: 50%;
	transform: translateX(-50%) scale(0);
	margin: 0;
	white-space: nowrap;
	border-radius: 4px;
	box-shadow: 0 0 15px 0 rgba(5, 5, 5, 0.3);
	font-size: 14px;
	transition: all 0.5s;
}
.advantage-show li span {
	position: absolute;
	left: -14px;
	top: -14px;
	display: block;
	width: 28px;
	height: 28px;
	line-height: 28px;
	font-size: 20px;
	text-align: center;
	/* //   background: #0067ed; */
	color: #fff;
	border-radius: 100%;
}

.advantage-show li {
	position: absolute;
	border-radius: 100%;
	display: block;
	background: #000;
	transition: all 0.5s;
	background-size: cover;
	background-repeat: no-repeat;
	background-position: 50%;
	box-shadow: 0 5px 32px 0 hsla(0, 0%, 53.3%, 0.24);
}
.advantage-show li p.aos-animate {
	transform: translateX(-50%) scale(1);
}

.advantage-show .one {
	width: 210px;
	height: 210px;
	left: 40%;
	top: 30%;
}
.advantage-show .two {
	width: 150px;
	height: 150px;
	left: 15%;
	top: 25%;
	-webkit-animation-delay: 0.5s;
	animation-delay: 0.5s;
}
.advantage-show .three {
	width: 135px;
	height: 135px;
	right: 16%;
	top: 5%;
	-webkit-animation-delay: 0.8s;
	animation-delay: 0.8s;
}
.advantage-show .four {
	width: 120px;
	height: 120px;
	left: 19%;
	bottom: 10%;
	-webkit-animation-delay: 0.3s;
	animation-delay: 0.3s;
}
.advantage-show .five {
	width: 100px;
	height: 100px;
	right: 10%;
	bottom: 20%;
	-webkit-animation-delay: 0.5s;
	animation-delay: 0.5s;
}
.advantage-show .six {
	width: 70px;
	height: 70px;
	left: 40%;
	top: 15%;
	-webkit-animation-delay: 0.8s;
	animation-delay: 0.8s;
}
.advantage-show .seven {
	width: 60px;
	height: 60px;
	right: 13%;
	top: 40%;
	-webkit-animation-delay: 0.3s;
	animation-delay: 0.3s;
}
.advantage-show .eight {
	width: 40px;
	height: 40px;
	right: 30%;
	bottom: 7%;
	-webkit-animation-delay: 1s;
	animation-delay: 1s;
}
.advantage-show .one p {
	font-size: 18px;
}
.upDown {
	-webkit-animation-name: upDown;
	animation-name: upDown;
	-webkit-animation-duration: 5s;
	animation-duration: 5s;
}
.animated {
	-webkit-animation-duration: 1s;
	animation-duration: 1s;
	-webkit-animation-fill-mode: both;
	animation-fill-mode: both;
}
.animated.infinite {
	-webkit-animation-iteration-count: infinite;
	animation-iteration-count: infinite;
}
.f70 {
	display: inline-block;
	color: #0067ed;
	line-height: 1;
	margin: 40px 0 20px;
	font-size: 60px;
}
.p16 {
	font-size: 16px;
	font-weight: 300;
}
@media screen and (max-width: 480px) {
	.advantage-show .one {
		width: 10.5rem;
		height: 10.5rem;
		left: 26%;
		top: 33%;
	}
	.advantage-show .two {
		width: 6.6rem;
		height: 6.6rem;
		left: 9%;
		top: 11%;
	}
	.advantage-show .three {
		width: 5.3rem;
		height: 5.3rem;
		right: 12%;
		top: 15%;
	}
	.advantage-show .four {
		width: 7rem;
		height: 7rem;
		left: 14%;
		bottom: 1%;
	}
	.advantage-show .five {
		width: 5.8rem;
		height: 5.8rem;
		right: 3%;
		bottom: 17%;
	}
	.advantage-show .six {
		width: 70px;
		height: 70px;
		left: 40%;
		top: 15%;
		-webkit-animation-delay: 0.8s;
		animation-delay: 0.8s;
	}
	.advantage-show .seven {
		width: 60px;
		height: 60px;
		right: 13%;
		top: 40%;
		-webkit-animation-delay: 0.3s;
		animation-delay: 0.3s;
	}
	.advantage-show .eight {
		width: 40px;
		height: 40px;
		right: 30%;
		bottom: 7%;
		-webkit-animation-delay: 1s;
		animation-delay: 1s;
	}
	.txtbox {
		padding: 20px 20px;
	}
	.img-block {
		width: 100%;
	}
}
.plus-icon-enter-active {
	transition: opacity 0.5s;
}
.plus-icon-enter {
	opacity: 0;
}
.plus-icon-leave-active {
	transition: opacity 0s;
}
.plus-icon-leave-to {
	opacity: 0;
}
p {
	margin-bottom: 11px;
}
.poL {
	position: absolute;
	width: 100%;
	bottom: 0px;
	left: 10px;
	text-align: left;
	color: white;
}
.poL h3 {
	margin-bottom: 20px;
	font-size: 24px;
	color: white;
}
.poR {
	position: absolute;
	width: 100%;
	bottom: 0px;
	left: 10px;
	text-align: left;
	color: white;
}
.poR h3 {
	margin-bottom: 20px;
	font-size: 24px;
	color: white;
}
.poA {
	position: absolute;
	top: 235px;
	left: 260px;
	text-align: left;
	/* background: white; */
	color: white;
}
.poA h3 {
	font-size: 30px;
	margin-bottom: 1rem;
	color: white;
}
.poA p {
	font-size: 22px;
}
.card-deck:nth-child(n + 1) {
	margin-top: 30px;
}
</style>
